import { createReducer } from "@reduxjs/toolkit";
import { updateSelectedHotspot } from "./actions";

// Initial state
const initialState = {
  selectedHotspot: null,
};

// Reducer
const HotpotsReducer = createReducer(initialState, (builder) => {
  builder.addCase(updateSelectedHotspot, (state, action) => {
    const { hotspotID } = action.payload;
    state.selectedHotspot = hotspotID;
  });
});

export default HotpotsReducer;
